import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Form, Input, Button, Icon, Label, List,
} from 'semantic-ui-react';
import SearchContext from '../../../contexts/SearchContext';

const SearchPhraseForm = () => {
  const history = useHistory();
  const { queries } = useContext(SearchContext);
  const [phrase, setPhrase] = useState('');

  const params = new URLSearchParams(useLocation().search);

  const addPhrase = () => {
    const newTerm = phrase.trim();
    if (newTerm) {
      params.append('queries', newTerm);
      params.set('page', 1);
      history.push({ pathname: '/search', search: `?${params.toString()}` });
    }
  };

  const removePhrase = (str) => {
    params.delete('queries', str);
    params.set('page', 1);
    history.push({ pathname: '/search', search: `?${params.toString()}` });
  };

  return (
    <Form onSubmit={addPhrase}>
      <Input
        fluid
        placeholder="Add search phrase"
        value={phrase}
        onChange={(e) => setPhrase(e.target.value)}
        label={(<Button icon><Icon name="search" /></Button>)}
        labelPosition="right"
      />
      <List>
        {queries.map((query) => (
          <List.Item key={query}>
            <Label>
              {queries.length > 1 && (
                <Icon
                  link
                  name="close"
                  onClick={() => removePhrase(query)}
                  style={{ marginRight: '0.5rem' }}
                />
              )}
              {query}
            </Label>
          </List.Item>
        ))}
      </List>

    </Form>
  );
};

export default SearchPhraseForm;
